enum BrandGuidelinesAgentToolName {
  UpdateBrandGuidelines = 'update-brand-guidelines',
  NavigateToBrandGuidelinesTab = 'navigate-to-brand-guidelines-tab',
  GetPersonaDetails = 'get-persona-details',
  AddOrUpdateBrandPersona = 'add-or-update-brand-persona',
}

export {BrandGuidelinesAgentToolName};
